export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-picker/node_modules/rmc-feedback/es/index.js
// module id = 328
// module chunks = 0